import { IEnvVars } from "shared/utils";

const QA_ENV_VARS: IEnvVars = {
  CLIENT_ID: "67154-ASDS-WebApp",
  API_ENDPOINT: "https://apm-settings-tool-exp.qaerospace1.honeywellaerospace.com/apm",
  FEL_ENDPOINT: "https://qasds.honeywellaerospace.com/servicerequest/elt/swlib/servicehome.do",
  ASDS_ENDPOINT: "https://qads.honeywellaerospace.com/ads/broadcast/message",
};

export default QA_ENV_VARS;
